 function showHideText_mobile(e,id,links){

        e.preventDefault();

        let linkIndex = Array.from({ length: links }, (_, i) => i + 1);

        if ($("#hidden-content-mobile" + id).css("display") === "none"){
            for (let i = 0; i < linkIndex.length; i++) {
                if ($("#hidden-content-mobile" + linkIndex[i]).is(":visible")) {
                    $("#icon-" + linkIndex[i]).css("background-image","url('{{ 'AddMajor.svg' | asset_url }}')")
                    $("#hidden-content-mobile" + linkIndex[i]).slideUp();
                }
            }
            $("#icon-" + id).css("background-image","url('{{ 'MinusIcon.svg' | asset_url }}')");
            $("#hidden-content-mobile" + id).slideDown()
        }else {
            $("#icon-" + id).css("background-image","url('{{ 'AddMajor.svg' | asset_url }}')");
            $("#hidden-content-mobile" + id).slideUp();
        }
    }

    function clickLogo_min() {
        let dom = $(".custom-footer-mobile .min-logoDiv-mobile .min-downloadUl-mobile")
        if (dom.css('display') == 'none') {
            dom.css('display', 'flex');
        } else {
            dom.css('display', 'none');
        }
    }

    function clickLogo_mobile() {
        let dom = $(".custom-footer-mobile .logoAndPayMethodDiv-mobile .rowBoxItem-mobile .logoDiv-mobile .downloadUl-mobile")
        if (dom.css('display') == 'none') {
            dom.css('display', 'flex');
        } else {
            dom.css('display', 'none');
        }
    }

    function footerLangChooseShow_mobile(){
        var currentStatus = $(".footerLangChoose-mobile").css('display');
        if (currentStatus == 'none'){
            $(".footerLangChoose-mobile").css('display','flex');
        }else {
            $(".footerLangChoose-mobile").css('display','none');
        }
    }

    function footerLangChooseShow(){
        var currentStatus = $(".footerLangChoose").css('display');
        if (currentStatus == 'none'){
            $(".footerLangChoose").css('display','flex');
            // transform: rotate(90deg);
            $(".footerActiveLangArrowSvg").css('transform','rotate(270deg)')
        }else {
            $(".footerLangChoose").css('display','none');
            $(".footerActiveLangArrowSvg").css('transform','rotate(90deg)')
        }
    }

    function hoverEffect() {
        const svg = $('.footerActiveCountryImg').find('.iconLinkSvg2 path');
        const text = $('.footerActiveLangText');

        // 切换图片、标题、描述、按钮的颜色
        svg.css(
                 {
                    'stroke':'#5BC0F8',
                    'stroke-width':'2'
                 }
                );

        text.css('color','#5BC0F8')

    }

    function resetEffect() {
        const svg = $('.footerActiveCountryImg').find('.iconLinkSvg2 path');
        const text = $('.footerActiveLangText');

        // 切换图片、标题、描述、按钮的颜色
        svg.css(
                {
                    'stroke':'#111',
                    'stroke-width':'2'
                }
            );

        text.css('color','#111')
    }

